module.exports = __webpack_public_path__ + "static/media/video_watch.a72f89ce.svg";